import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { getNumberOfDecimal } from "../../utils/Number";
import { isValueInChoiceList } from "../../utils";

const numberOfDecimalsKey = "NumberOfDecimals";
const errorKey = "InvalidNumber";

export function numberOfDecimals(question, variable) {
    const { name: variableName } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());
        if (mentions.length) {
            const mentionValue = mentions[0].value;
            const nbDecimal = getNumberOfDecimal(mentionValue);
            const nbDecimalDefine = parseInt(question.settings[numberOfDecimalsKey], 10);

            // The number 28 comes from dotnet decimal.Round which is used on server side
            if (nbDecimalDefine >= 0 && nbDecimalDefine <= 28) {
                const isValid =
                    isValueInChoiceList(mentionValue, variable) || nbDecimal <= nbDecimalDefine;

                if (!isValid) {
                    return { variableName, error: { key: errorKey } };
                }
            }
        }
        return null;
    };
}
